import React from 'react';
import { Accordion } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is imported
import '../../styles/transport.css'; // Import specific CSS for styling
import '../../styles/Fonts.css'; // Import font styling if needed

const faqData = [
  {
    question: 'What types of transportation services do you offer?',
    answer: (
      <p className='poppins-regular text-start'>
        We offer a comprehensive range of transportation services, including road, rail, air, and sea options. 
        Our services can be customized based on the size of your shipment, your destination, and the speed at which you require delivery.
      </p>
    ),
  },
  {
    question: 'Are there any shipment restrictions or limitations?',
    answer: (
      <p className='poppins-regular text-start'>
        Yes, there are certain restrictions and limitations on shipments due to local or international regulations. 
        We recommend contacting our support team for detailed information regarding any specific restrictions that may apply to your shipment.
      </p>
    ),
  },
  {
    question: 'Do you handle international shipments?',
    answer: (
      <p className='poppins-regular text-start'>
        Yes, we manage international shipments and ensure that all customs regulations are strictly adhered to. 
        Our team is experienced in handling the complexities of international shipping, ensuring a smooth and hassle-free process.
      </p>
    ),
  },
  {
    question: 'How can I track my shipment?',
    answer: (
      <p className='poppins-regular text-start'>
        You can track your shipment in real-time using our advanced tracking system, which is accessible through our website. 
        Simply enter your tracking number, and you will receive up-to-date information about your shipment’s status and estimated delivery time.
      </p>
    ),
  },
];

const TrackFAQ = () => {
  return (
    <section id="faq" className="py-5 faq-section">
      <div className="container">
        <div className="my-2 text-center">
          <button disabled className="custom-button mb-2 poppins-semibold text-dark">FAQ</button>
        </div>
        <h2 className="poppins-bold text-dark fs-1 mb-4">Frequently Asked Questions</h2>
        <Accordion>
          {faqData.map((faq, index) => (
            <Accordion.Item eventKey={index.toString()} key={index}>
              <Accordion.Header className="poppins-extrabold">
                <h5 className="poppins-medium mb-0">{faq.question}</h5>
              </Accordion.Header>
              <Accordion.Body className="poppins-regular text-start">
                {faq.answer}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default TrackFAQ;
